import React, { useState } from 'react'; // import ContentCopyIcon from '@material-ui/icons/ContentCopy';

import FileCopyIcon from '@material-ui/icons/FileCopy';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';
import { colorText } from '../theme/palette';

const CopyButton = ({
  textToCopy,
  tooltip = 'Copiar link',
  copiedTooltip = 'Copiado!',
  iconSize = '20px',
  placement = 'bottom',
  dir = 'ltr',
  className = '',
  style = {}
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }
  };

  return <Tooltip text={copied ? copiedTooltip : tooltip} placement={placement} dir={dir}>
      <button onClick={handleCopy} className={`bg-transparent border-0 p-0 m-0 ${className}`} style={{
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...style
    }}>
        {copied ? <CheckCircleOutlineIcon style={{
        fontSize: iconSize,
        color: 'green'
      }} /> : <FileCopyIcon style={{
        fontSize: iconSize,
        color: colorText
      }} />}
      </button>
    </Tooltip>;
};

CopyButton.propTypes = {
  textToCopy: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  copiedTooltip: PropTypes.string,
  iconSize: PropTypes.string,
  placement: PropTypes.string,
  dir: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default CopyButton;